import React, { useState } from "react";
import { Star } from "lucide-react";

export function StarRating({ value, onChange, size = 24, readOnly = false, testId }) {
  const [hover, setHover] = useState(0);
  const display = hover || value || 0;
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onClick={() => !readOnly && onChange?.(n)}
          onMouseEnter={() => !readOnly && setHover(n)}
          onMouseLeave={() => !readOnly && setHover(0)}
          className={`transition ${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"}`}
          aria-label={`${n} star${n === 1 ? "" : "s"}`}
          data-testid={testId ? `${testId}-${n}` : `star-${n}`}
        >
          <Star
            size={size}
            className={n <= display ? "fill-amber-400 text-amber-400" : "text-slate-300"}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
}

export function StarDisplay({ stars, size = 14 }) {
  const s = Number(stars) || 0;
  return (
    <div className="inline-flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={n <= s ? "fill-amber-400 text-amber-400" : "text-slate-300"}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}
